import type { SmartGuideBrowserLocation } from "./SmartGuideBrowserLocation";

export const destinationEntryChangedEventName = "smartguide:destination-entry-changed";

export type SmartGuideDestinationEntry = {
    inside: boolean;
    location: SmartGuideBrowserLocation;
};

export function destinationEntryFromEvent(event: Event): SmartGuideDestinationEntry | undefined {
    const detail = (event as CustomEvent<unknown>).detail;
    if (!detail || typeof detail !== "object") {
        return undefined;
    }

    const entry = detail as SmartGuideDestinationEntry;
    if (typeof entry.inside !== "boolean" || !_isFiniteGpsLocation(entry.location)) {
        return undefined;
    }

    return entry;
}

export function dispatchDestinationEntryChanged(entry: SmartGuideDestinationEntry): void {
    if (!_isFiniteGpsLocation(entry.location)) {
        return;
    }

    document.dispatchEvent(new CustomEvent<SmartGuideDestinationEntry>(destinationEntryChangedEventName, {
        detail: entry
    }));
}

function _isFiniteGpsLocation(location: SmartGuideBrowserLocation | undefined): location is SmartGuideBrowserLocation {
    return !!location &&
        location.source === "gps" &&
        Number.isFinite(location.latitude) &&
        Number.isFinite(location.longitude) &&
        Number.isFinite(location.timestamp);
}
